import script from "./ApiAccessTokenForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiAccessTokenForm.vue?vue&type=script&setup=true&lang=ts"

import "../mypage.css?vue&type=style&index=0&id=b77c28be&scoped=true&lang=css"
import "./ApiAccessTokenForm.vue?vue&type=style&index=1&id=b77c28be&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b77c28be"]])

export default __exports__